import Looper from "../components/Looper";
import { fetcher, getQuestion, initConfig, initValues } from "./fetcher";
import { RESET_APP } from "../actions/action-types";
import {
  GROUP_QUESTION_RESPONSE,
  STEP_CODE_INIT_LOOPER,
  STEP_CODE_LOOPER,
  STEP_SEPARATOR,
  STEP_CODE_IDENTIFY
} from "./constants";
import ConnexionInscription from "../components/ConnexionInscription";
import AvailableAppointment from "../components/AvailableAppointment";
import { reverseObjectByKey } from "./helper";
import "url-search-params-polyfill";
import { nextStep } from "../actions";
import { store } from "../store";
import InscriptionAdmin from "../components/InscriptionAdmin";

const baseStep = {
  label: "",
  byPass: false,
  code: "",
  component: {
    type: null,
    label: ""
  },
  data: {
    fetchSource: null,
    formatSource: null,
    keyValue: "",
    key: ""
  },
  returned: {
    key: "",
    dataKey: ""
  },
  stepper: {
    previous: 0,
    next: 0
  },
  selfRemove: {
    group: null
  }
};

const widgetTypeToScnr = {
  anest: "scnr1",
  normal: "scnr2",
  question: "scnr3"
};

const buildSteps = stepsLabel => {
  const steps = _scenario.buildSteps(stepsLabel);

  steps.push(buildStepAppointment(stepsLabel[2]));
  steps.push(buildStepIdentity(stepsLabel[3]));
  steps.push(buildStepSummary(stepsLabel[4]));
  return steps;
};

const buildStepAppointment = stepLabel => {
  const displayAppointment = initValues().appointment;
  const step = createStep(
    {
      label: stepLabel,
      component: { type: AvailableAppointment },
      data: {
        fetchSource:
          displayAppointment === "calendar"
            ? _scenarioFetcher.getAvailableAppointmentCalendar
            : _scenarioFetcher.getAvailableAppointment
      }
      //stepper: { previous: 1 }
    },
    true
  );
  step.children.push(createStep({ stepper: { previous: 1 } }));
  return step;
};

const buildStepIdentity = stepLabel => {
  const step = createStep({ label: stepLabel }, true);
  const from = store.getState().returnedValue.from;

  const coInsc = createStep({
    code: STEP_CODE_IDENTIFY,
    label: stepLabel,
    component: {
      type: from === "admin" ? InscriptionAdmin : ConnexionInscription
    }
  });
  step.children.push(coInsc);

  return step;
};

const buildStepSummary = stepLabel => {
  return createStep({ label: stepLabel }, true);
};

let _scenario;
let _scenarioFetcher;
const instance = widgetType => {
  const displayAppointment = initValues().appointment;
  const scnr = widgetTypeToScnr[widgetType];
  _scenario = require(`./scenario/${scnr}`);
  _scenarioFetcher = require(`./scenario/${scnr}-fetcher`);
  return {
    buildSteps: stepsLabel => buildSteps(stepsLabel),
    getFetcherUrls: () => _scenarioFetcher.getUrls(),
    getAvailableAppointment: () =>
      displayAppointment === "calendar"
        ? _scenarioFetcher.getAvailableAppointmentCalendar
        : _scenarioFetcher.getAvailableAppointment
  };
};

export default instance;

export const createStep = (step, hasChildren = false) => {
  const newStep = { ...baseStep, ...step };
  if (hasChildren) {
    newStep.children = [];
  }

  return newStep;
};

export const createLooperStep = (isFirst = false) => {
  return createStep({
    code: isFirst ? STEP_CODE_INIT_LOOPER : STEP_CODE_LOOPER,
    component: {
      type: Looper
    },
    data: {
      fetchSource: getQuestion
    },
    returned: {
      key: "idquestion"
    },
    selfRemove: {
      group: GROUP_QUESTION_RESPONSE
    }
  });
};

export const searchStep = (steps, activeStep) => {
  const step = steps[activeStep.step];
  if (step && step.children) {
    const subStep = step.children[activeStep.subStep];
    if (subStep) {
      return subStep;
    }
  }
  return step;
};

export const searchSelfRemoveSubStep = (steps, group) => {
  const toRemove = {};
  for (const stepIndex in steps) {
    if (Object.prototype.hasOwnProperty.call(steps, stepIndex)) {
      const step = steps[stepIndex];
      if (step.children.length) {
        step.children.forEach((subStep, subStepIndex) => {
          if (subStep.selfRemove.group === group) {
            toRemove[`${stepIndex}${STEP_SEPARATOR}${subStepIndex}`] = subStep;
          }
        });
      }
    }
  }
  // reverse key
  return reverseObjectByKey(toRemove);
};

export const goToBeginning = () => {
  return dispatch => {
    dispatch({ type: RESET_APP });
    dispatch(initConfig(true));
    fetcher(true);
  };
};

export const goToNextStep = () => {
  return (dispatch, getState) => {
    dispatch(nextStep(getState().steps));
  };
};

export const searchStepByCode = (steps, code) => {
  for (const stepIndex in steps) {
    if (Object.prototype.hasOwnProperty.call(steps, stepIndex)) {
      const step = steps[stepIndex];
      if (step.children.length) {
        const childrenLength = step.children.length;
        for (
          let subStepIndex = 0;
          subStepIndex < childrenLength;
          subStepIndex++
        ) {
          if (step.children[subStepIndex].code === code) {
            return { step: +stepIndex, subStep: +subStepIndex };
          }
        }
      }
    }
  }
  return null;
};
